import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

function formatError(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin) navigate(admin.role === "consignador" ? "/portal" : "/admin", { replace: true });
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Bienvenido");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <span className="w-12 h-12 rounded-2xl bg-zinc-900 text-white grid place-items-center text-lg font-bold mb-4">P</span>
          <h1 className="text-2xl font-semibold tracking-tight">Panel PuntoCell</h1>
          <p className="text-sm text-zinc-500 mt-1">Acceso exclusivo de administración</p>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <Label htmlFor="email" className="text-xs text-zinc-500">Correo</Label>
            <Input id="email" type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@puntoplay.com" className="mt-1.5 h-12 rounded-xl" required />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs text-zinc-500">Contraseña</Label>
            <Input id="password" type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mt-1.5 h-12 rounded-xl" required />
          </div>
          <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full h-14 rounded-2xl text-base font-semibold bg-zinc-900 hover:bg-zinc-800">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Lock className="w-4 h-4 mr-2" /> Entrar</>}
          </Button>
        </form>

        <button onClick={() => navigate("/")} className="w-full mt-6 text-sm text-zinc-400 flex items-center justify-center gap-2 hover:text-zinc-600 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Volver a la calculadora
        </button>
      </div>
    </div>
  );
}
